export default __webpack_public_path__ + "BoxFlagFilled.svg?cb1ef1d55d7203b4178861ca92aee2e5";